import BaseService from '@/services/BaseService'
import { http } from './config'

class ProdutoReservaService {
    baixarReserva(produtoId){
        return http.get(`/v1/reserva/produto/${produtoId}/baixar`)
    }
}

export default new ProdutoReservaService